module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.faIconClass !== '' || _vm.text !== '') ? _c('div', {
    staticClass: "a-toggle"
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.$emit('toggleEditable')
      }
    }
  }, [(_vm.faIconClass !== '') ? _c('i', {
    class: _vm.faIconClass,
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(_vm._s(_vm.text) + "\n  ")])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f93284a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/atoms/ToggleText.vue
// module id = 540
// module chunks = 2